// extracted by mini-css-extract-plugin
module.exports = {"date":"AnnouncementListItem_date__WySi4","title":"AnnouncementListItem_title__39tXg","descriptionText":"AnnouncementListItem_descriptionText__3dkaQ"};